import React from 'react'
import "../Ahmedabadprices/Ahmedabadprice.css"; 
import { Pricecard } from '../Pricecard/Pricecard.jsx';

export default function Ahmedabadprice() {
  return (
    <>
        <div className="Ahmedabadprice">
          <div className="container-fluid">
            <div className="container">
                <h1 className='text-center Ahmedabadprice_title'>PRICING <span className="green">AHMEDABAD</span></h1>
                <div className="mx-auto border-3 title-border-bottom w-50"></div>
              <div className="row Ahmedabadprice_Outer pt-4">
                <div className="col-12 col-md-6 Ahmedabadprice_card g-5">
                    <Pricecard
                        packagesName="Single Session"
                        packagePrice="749/-"
                        pkalistpoint1="Daily Online Payment"
                        pkalistpoint2="Session: Upto 45 Minutes"
                        pkalistpoint3="For Single Session"
                        pkalistpoint4="Alternate Session"
                        packagesLink="/about"
                        pkabuttonText="BOOK NOW"
                        
                    />
                </div>
                <div className="col-12 col-md-6 Ahmedabadprice_card g-5">
                    <Pricecard
                        packagesName="7 Days Package"
                        packagePrice="5075/-"
                        pkalistpoint1="Advance Online Payment"
                        pkalistpoint2="Session: Upto 45 Minutes"
                        pkalistpoint3="For 7 Session"
                        pkalistpoint4="No Alternate Session"
                        packagesLink="/about"
                        pkabuttonText="BOOK NOW"
                        
                    />
                </div>
                <div className="col-12 col-md-6 Ahmedabadprice_card g-5">
                    <Pricecard
                        packagesName="15 Days Package"
                        packagePrice="10500/-"
                        pkalistpoint1="Advance Online Payment"
                        pkalistpoint2="Session: Upto 45 Minutes"
                        pkalistpoint3="For 15 Session"
                        pkalistpoint4="No Alternate Session"
                        packagesLink="/about"
                        pkabuttonText="BOOK NOW"
                        
                    />
                </div>
                <div className="col-12 col-md-6 Ahmedabadprice_card g-5">
                    <Pricecard
                        packagesName="30 Days Package"
                        packagePrice="19500/-"
                        pkalistpoint1="Advance Online Payment"
                        pkalistpoint2="Session: Upto 45 Minutes"
                        pkalistpoint3="For 30 Session"
                        pkalistpoint4="No Alternate Session"
                        packagesLink="/about"
                        pkabuttonText="BOOK NOW"
                        
                    />
                </div>
              </div>
            </div>
          </div>
        </div>
    </>
  )
}
